<template>
	<div>
		<el-dialog class="close-private cps-dialog-icon-line-height"
            size="small"
			:visible.sync="visible"
			:title="$t('listPage.text.delete')"
			:close-on-click-modal="false"
			:before-close="handleClose">
			<div class="i-text">
				<div class="tip-warning mb20 lh20"
					v-html="$t('nat.speechCraft.deteteNatTip')">
				</div>
			</div>
			<div class="reinstall-tip">
				{{$t('nat.speechCraft.sureDeleteNat', [rowInfo.name])}}
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelDel">{{ $t('privateNetInstance.cancel') }}</el-button>
				<el-button @click="sureDel" type="primary">
					{{ $t('privateNetInstance.sure') }}
				</el-button>
			</div>
		</el-dialog>
		<jcb-opt-protect 
			:visible.sync="operationProtectVisible" 
			:action-type="OperationConstant.DELETE_NAT"
			@success="onSuccess" @error="onError">
		</jcb-opt-protect>
	</div>
</template>

<script>
import operationProtect from '@/mixins/operationProject';
import { OperationConstant } from '@/common/Constants';

export default {
  name: 'DeleteNat',
  mixins: [operationProtect],

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowInfo: {
      type: Object,
      default: () => {}
    },
    pageSource: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 操作保护弹框是否显示
      operationProtectVisible: false,
    };
  },
  computed: {
    OperationConstant: () => OperationConstant
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    },
    /**
		 * 取消删除操作
		 */
    cancelDel() {
      this.handleClose();
    },
    /**
		 * 确定删除打开操作保护
		 */
    sureDel() {
      this.openOperationProtect(OperationConstant.DELETE_NAT, this.rowInfo, this.pageSource);
      this.handleClose();
    },
    /**
		 * 删除nat网关
		 * @param headers
		 */
    deleteNat(headers) {
      const params = {
        natGatewayId: this.rowInfo.natGatewayId,
        region: this.rowInfo.region,
		clientToken: this.clientToken,
      };
      Ajax.del('/api/cps/nat/delete', params, { headers }).then(() => {
        this.$emit('refresh');
      }).catch(async (err) => {
          const { response } = err.data;
          const json = await response.json();
          this.$message.error(json.errmsg);
          if (json.errno === 20106) {
            this.$emit('refresh');
          }
      })
      .finally(() => {
        this.handleClose();
      });
    },
  },

};
</script>

<style lang="scss">
	.close-private{
		.reinstall-confirm-checkbox{
			margin-top: 30px;
			margin-bottom: -20px;
			.jc-checkbox__label{
				color:rgb(121, 121, 121)
			}
		}
		.reinstall-tip {
			width:100%;
			font-size:15px;
            text-align: center;
			color:#797979;
			word-break: break-word;
			padding-bottom: 5px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/nat/DeleteNat.vue